export enum UserDisabledStatus {
  CompanyDisabled = '1',
  CompanyOffline = '2',
  UserDisabled = '3',
  Other = '99',
}
